import { createStyles, darken, makeStyles, Theme, lighten, alpha } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    const backgroundColor = (color: string, { light = 0.9, dark = 0.8 } = {}) => {
        return theme.palette.type === 'light' ? lighten(color, light) : darken(color, dark);
    };

    const backgroundColorHover = (color: string) => {
        return theme.palette.type === 'light' ? darken(color, 0.04) : lighten(color, 0.08);
    };

    const borderColor =
        theme.palette.type === 'light' ? theme.palette.divider : darken(alpha(theme.palette.divider, 1), 0.68);

    return createStyles({
        root: {
            '&$stripedOdd&:nth-of-type(odd), &$stripedOdd&:nth-of-type(odd) > [class*="MuiTableCell-sticky"]': {
                backgroundColor: backgroundColorHover(theme.palette.background.paper),
            },
            '&$stripedEven&:nth-of-type(even), &$stripedEven&:nth-of-type(even) > [class*="MuiTableCell-sticky"]': {
                backgroundColor: backgroundColorHover(theme.palette.background.paper),
            },
            '&$hover:hover, &$hover:hover > [class*="MuiTableCell-sticky"]': {
                backgroundColor: backgroundColorHover(theme.palette.background.paper),
            },
            '&$edited:hover, &$edited:hover > [class*="MuiTableCell-sticky"]': {
                backgroundColor: backgroundColor(theme.palette.warning.light, { light: 0.8, dark: 0.7 }),
            },
            '&$edited, &$edited > [class*="MuiTableCell-sticky"]': {
                backgroundColor: backgroundColor(theme.palette.warning.light),
            },
            '&$selected:hover, &$selected:hover > [class*="MuiTableCell-sticky"]': {
                backgroundColor: backgroundColor(theme.palette.primary.light, { light: 0.8, dark: 0.7 }),
            },
            '&$selected, &$selected > [class*="MuiTableCell-sticky"]': {
                backgroundColor: backgroundColor(theme.palette.primary.light),
            },
            '&$bordered > [class*="MuiTableCell-root"]': {
                borderLeft: `1px solid ${borderColor}`,
                '&:first-of-type': {
                    borderLeft: 0,
                },
            },
        },
        stripedOdd: {},
        stripedEven: {},
        hover: {},
        edited: {},
        selected: {},
        bordered: {},
    });
};

export default makeStyles(styles, { name: 'MuiTableRow' });
